import { Component, HostBinding, Input } from '@angular/core';

export type CardStyle = 'primary' | 'secondary';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() cardStyle: CardStyle = 'primary';

  @HostBinding('class.-primary') get isPrimary() {
    return this.cardStyle === 'primary';
  }

  @HostBinding('class.-secondary') get isSecondary() {
    return this.cardStyle === 'secondary';
  }
}
